import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import logoD from "../assets/Planner.png";
import logoL from "../assets/ASitesPlanner (1).png";
import { RiSettings3Fill } from "react-icons/ri";
// import { useAuth } from "../contexts/AuthContext";
import { FaUserLarge, FaCalendarCheck, FaMoon } from "react-icons/fa6";
import { IoLanguageSharp } from "react-icons/io5";
import { IoIosSunny } from "react-icons/io";
import { useAuth } from "../contexts/AuthContext";
import { getAuth } from "firebase/auth";
import AgendaPopup from "../components/AgendaPopup";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import flags
import enFlag from "../assets/flags/engFlag.webp";
import alFlag from "../assets/flags/albanianFlag.png";
import frFlag from "../assets/flags/frFlag.webp";
import deFlag from "../assets/flags/grFlag.jpg";

const Navbar = ({ theme, switchTheme }) => {
  const { isAdmin } = useAuth();
  const { currentUser } = useAuth();
  const [isAgendaOpen, setIsAgendaOpen] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const languageDropdownRef = useRef(null);
  const { t, i18n } = useTranslation();

  const auth = getAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Define available languages with their data
  const languages = [
    {
      code: "en",
      name: "English",
      flag: enFlag,
      nativeName: "English",
    },
    {
      code: "al",
      name: "Albanian",
      flag: alFlag,
      nativeName: "Shqip",
    },
    {
      code: "fr",
      name: "French",
      flag: frFlag,
      nativeName: "Français",
    },
    {
      code: "de",
      name: "German",
      flag: deFlag,
      nativeName: "Deutsch",
    },
  ];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setShowLanguageDropdown(false);

    // Update HTML direction for RTL languages
    if (languageCode === "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  };

  const getCurrentLanguage = () => {
    return (
      languages.find((lang) => lang.code === i18n.language) || languages[0]
    );
  };

  return (
    <Container>
      <AgendaPopup
        isOpen={isAgendaOpen}
        onClose={() => setIsAgendaOpen(false)}
      />
      {theme === "dark" ? (
        <img src={logoD} alt="" style={{ transition: 0.5 }} />
      ) : (
        <img src={logoL} alt="" style={{ transition: 0.5 }} />
      )}

      <div className="icons">
        {/* 🎯 NEW AGENDA BUTTON */}
        <FaCalendarCheck
          className="icon"
          onClick={() => setIsAgendaOpen(true)}
          title="Open Today's Agenda"
        />

        {/* 🌐 LANGUAGE SELECTOR */}
        <div className="language-selector" ref={languageDropdownRef}>
          <IoLanguageSharp
            className="icon"
            onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
            title={t("navbar.changeLanguage") || "Change Language"}
          />

          {showLanguageDropdown && (
            <div className="language-dropdown">
              {languages.map((language) => (
                <div
                  key={language.code}
                  className={`language-option ${
                    i18n.language === language.code ? "active" : ""
                  }`}
                  onClick={() => handleLanguageChange(language.code)}
                >
                  <img
                    src={language.flag}
                    alt={language.name}
                    className="language-flag"
                  />
                  <div className="language-info">
                    <span className="language-name">{language.name}</span>
                    <span className="language-native">
                      {language.nativeName}
                    </span>
                  </div>
                  {i18n.language === language.code && (
                    <span className="language-check">✓</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* THEME TOGGLE BUTTON - Circular like other icons */}
        <ThemeToggleButton
          className="icon"
          onClick={switchTheme}
          title={
            theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"
          }
        >
          {theme === "dark" ? <IoIosSunny /> : <FaMoon />}
        </ThemeToggleButton>

        <Link to={"/settings"}>
          <RiSettings3Fill className="icon" />
        </Link>

        {/* User account section */}
        {isAdmin ? (
          <Link to="/admin" style={{ textDecoration: "none" }}>
            <div className="acc">
              Admin
              <FaUserLarge className="icon" />
            </div>
          </Link>
        ) : (
          <Link to="/account" style={{ textDecoration: "none" }}>
            <div className="acc">
              {currentUser.displayName}
              <FaUserLarge className="icon" />
            </div>
          </Link>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  transition: 0.5s;

  img {
    display: flex;
    margin: auto;
    margin-bottom: 10px;
    width: 200px;
    transition: 0.5s;
    margin-left: 37%;
  }

  @media (max-width: 1150px) {
    img {
      display: none;
    }
    justify-content: end;
  }

  @media (max-width: 650px) {
    position: fixed;
    height: 90px;
    z-index: 10000;
    top: 0em;
    left: 0;
    padding-top: 1em;
    width: 100%;
    backdrop-filter: blur(10px);
    --webkit-backdrop-filter: blur(10px);
    height: 65px;
    img {
      display: flex;
      margin: auto;
      width: 110px;
      margin-top: -1%;
    }
    .icons {
      /* display: none; */
    }
  }

  .icons {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-self: end;
    align-self: end;
    gap: 1em;
    @media (max-width: 650px) {
      display: none;
    }

    @media (max-width: 1000px) {
      justify-content: flex-end;
    }

    /* Language Selector Styles */
    .language-selector {
      position: relative;
      display: inline-block;
    }

    .icon {
      padding: 17px;
      color: var(--fontPrimaryColor);
      border-radius: 50%;
      cursor: pointer;
      font-size: 3.5em;
      background-color: var(--secondaryBackgroundColor);
      transition: 0.5s;

      &:hover {
        background-color: var(--thirdBackgroundColor);
      }

      @media (max-width: 650px) {
        display: none;
      }
    }

    .language-dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      min-width: 200px;
      background: var(--primaryBackgroundColor);
      border: 1px solid var(--borderColor);
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      overflow: hidden;
      margin-top: 5px;

      .language-option {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        cursor: pointer;
        transition: background-color 0.2s;
        border-bottom: 1px solid var(--borderColor);

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: var(--secondaryBackgroundColor);
        }

        &.active {
          background-color: var(--thirdBackgroundColor);
        }

        .language-flag {
          width: 24px;
          height: 16px;
          border-radius: 2px;
          margin-right: 12px;
          object-fit: cover;
        }

        .language-info {
          display: flex;
          flex-direction: column;
          flex-grow: 1;

          .language-name {
            font-size: 0.9em;
            font-weight: 500;
            color: var(--fontPrimaryColor);
          }

          .language-native {
            font-size: 0.8em;
            color: var(--fontSecondaryColor);
          }
        }

        .language-check {
          color: var(--primaryColor);
          font-weight: bold;
        }
      }
    }

    .acc {
      color: white;
      border-radius: 30px;
      cursor: pointer;
      display: flex;
      gap: 10px;
      align-items: center;
      padding: 15px 25px;
      background-color: #495269;
      cursor: pointer;
      transition: 0.5s;

      @media (max-width: 650px) {
        display: none;
      }

      &:hover {
        background-color: #2b3347;
      }

      .icon {
        padding: 0;
        color: white;
        border-radius: 50%;
        cursor: pointer;
        font-size: 1.5em;
        background-color: #495269;

        &:hover {
          background-color: #2b3347;
        }
      }
    }
  }
`;

// Styled component for the theme toggle button
const ThemeToggleButton = styled.button`
  padding: 1px;
  color: var(--fontPrimaryColor);
  border-radius: 50%;
  cursor: pointer;
  font-size: 3.5em;
  background-color: var(--secondaryBackgroundColor);
  transition: 0.5s;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 58px; */
  /* height: 58px; */

  &:hover {
    background-color: var(--thirdBackgroundColor);
  }

  @media (max-width: 650px) {
    display: none;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export default Navbar;
